export default theme => ({
  confirm: {
    marginBottom: 20,
  },
  table: {
    marginTop: 20,
  },
});
